/**
 * First-card celebration gating.
 * Show once per user when collection goes empty → non-empty.
 * localStorage prevents repeat after wipe + re-add.
 */

const storageKey = (userId) => `tradeloft:firstCardCelebrated:${userId}`;

export function hasCelebratedFirstCard(userId, storage = localStorage) {
  if (!userId) return true;
  try {
    return storage.getItem(storageKey(userId)) === "1";
  } catch {
    return false;
  }
}

export function markFirstCardCelebrated(userId, storage = localStorage) {
  if (!userId) return;
  try {
    storage.setItem(storageKey(userId), "1");
  } catch {
    /* private mode — celebration may repeat; acceptable */
  }
}

/**
 * @returns {boolean} whether to open the celebration overlay
 */
export function shouldCelebrateFirstCard({
  userId,
  wasEmpty,
  isLoading,
  storage = localStorage,
}) {
  if (!userId || isLoading || !wasEmpty) return false;
  if (hasCelebratedFirstCard(userId, storage)) return false;
  return true;
}
